import { convertStringToFloat, formatShortNumber } from 'react/utils/NumberUtils';

/**
 * Format number with K/M/B notation for large numbers
 * @param {number|string} value - Value to format
 * @param {number} decimals - Number of decimal places
 * @returns {string} Formatted number
 */
export const formatNumber = (value, decimals = 2) => formatShortNumber(value, decimals);

/**
 * Handle sort item - convert to lowercase string or number for comparison
 * @param {*} sortItem - Item to process for sorting
 * @returns {string|number} Processed item
 */
export const handleSortItem = (sortItem) => {
  if (sortItem) {
    if (isNaN(sortItem)) {
      return String(sortItem).toLowerCase();
    }
    return convertStringToFloat(sortItem);
  }
  return sortItem;
};

/**
 * Sort array by specified sort configuration
 * @param {Array} arr - Array to sort
 * @param {Object} sort - Sort configuration { order, reverse }
 * @returns {Array} Sorted array
 */
export const sortArray = (arr, sort) => {
  if (!arr || arr.length === 0) return arr;

  const sorted = [...arr].sort((a, b) => {
    let x = a[sort.order] || '';
    let y = b[sort.order] || '';

    x = handleSortItem(x);
    y = handleSortItem(y);

    if (sort.reverse && y === 'n/a') return -1;
    if (!sort.reverse && x === 'n/a') return 1;

    const orderValue = sort.reverse ? -1 : 1;
    return x > y ? orderValue : -orderValue;
  });

  return sorted;
};

/**
 * Generate column class name from column config
 * @param {Object} col - Column configuration
 * @returns {string} CSS class name
 */
export const columnClass = (col) => col.title.toLowerCase().replace(/\s/g, '') || col.id;
